module.exports = __webpack_public_path__ + "img/4.6c0a3a67.jpg";